// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @keyframes zIndexOut {
  from {
    z-index: 1;
    opacity: 1;
    pointer-events: auto;
  }

  to {
    z-index: 0;
    opacity: 0;
  	pointer-events: none;
  }
}

.zIndexOut.animated .zIndex-animation {
  animation-name: zIndexOut;
}

.zIndexOut {
	position: relative;
  animation-name: zIndexOut;
} */
`, "",{"version":3,"sources":["webpack://./resources/assets/js/scss/custom-animate/zIndex_exits/zIndexOut.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;GAqBG","sourcesContent":["/* @keyframes zIndexOut {\n  from {\n    z-index: 1;\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  to {\n    z-index: 0;\n    opacity: 0;\n  \tpointer-events: none;\n  }\n}\n\n.zIndexOut.animated .zIndex-animation {\n  animation-name: zIndexOut;\n}\n\n.zIndexOut {\n\tposition: relative;\n  animation-name: zIndexOut;\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
